import React from 'react';

import useScreenOrientation from './helpers/useScreenOrientation';

import introTitle from "../assets/images/Tittle_Registro.png";

export default function UserForm({ isVisible, setView, setUserID }: any) {

  const isLandscape = useScreenOrientation();

  const [storeName, setStoreName] = React.useState("");
  const [storeNameError, setStoreNameError] = React.useState(false);

  const [localNumber, setLocalNumberNote] = React.useState("");
  const [localNumberError, setLocalNumberError] = React.useState(false);

  const [mallName, setMallName] = React.useState("");
  const [mallNameError, setMallNameError] = React.useState(false);

  const [promissoryNote, setPromissoryNote] = React.useState("");
  const [promissoryNoteError, setPromissoryNoteError] = React.useState(false);

  const [acceptTerms, setAcceptTerms] = React.useState(false);
  const [acceptTermsError, setAcceptTermsError] = React.useState(false);

  const [sendingForm, setSendingForm] = React.useState(false);

  const checkStoreName = (name: string) => {
    const filteredName = name.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    setStoreName(filteredName)
    setStoreNameError(filteredName === '')
  };

  const checkLocalNumber = (number: string) => {
    setLocalNumberNote(number)
    setLocalNumberError(number === '')
  };

  const checkMallName = (name: string) => {
    const filteredName = name.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    setMallName(filteredName)
    setMallNameError(filteredName === '')
  };

  const checkPromissoryNote = (promissoryNote: string) => {
    setPromissoryNote(promissoryNote)
    setPromissoryNoteError(promissoryNote === '')
  };

  const checkTerms = (accepted: boolean) => {
    setAcceptTerms(accepted)
    setAcceptTermsError(accepted === false)

    checkStoreName(storeName);
    checkLocalNumber(localNumber);
    checkMallName(mallName);
    checkPromissoryNote(promissoryNote);
  };

  const verifyAllInputs = () => {
    checkStoreName(storeName);
    checkLocalNumber(localNumber);
    checkMallName(mallName);
    checkPromissoryNote(promissoryNote)
    checkTerms(acceptTerms)
    if(storeNameError === false && 
      mallNameError === false &&
      localNumberError === false &&
      promissoryNoteError === false &&
      acceptTermsError === false &&
      acceptTerms === true){
        SendUserDataForm()
    }
  };

  const SendUserDataForm = () => {
    setSendingForm(true);
    
    fetch('https://x0cv9pf8rj.execute-api.us-east-1.amazonaws.com/api/soniador/registre', {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(
        {          
          "mallName": mallName,
          "localNumber": localNumber,
          "storeName": storeName,
          "promissory_note": promissoryNote,
        }
      )
    }
    ).then(response => {
      setSendingForm(false)
      response.json().then(jSonResponse => {
        if (jSonResponse.statusCode === 200) {
          console.log("User Data Form Sent!")
          setUserID(jSonResponse.id)
          setView("Instructions")
        }
        console.log(jSonResponse)
      })
    }
    )
      .then(responseData => {
        console.log(responseData)
      })
      .catch(error => {
        console.error("Error sending User Data Form")
        console.error(error)
        setSendingForm(false)
      });
  }

  return (
    <div className={`full-userform-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`userform-container ${isLandscape ? '' : 'portrait'}`}>

        <img className={`userform-container-header ${isLandscape ? '' : 'portrait'}`} src={introTitle} alt=''/>

        <div className={`userform-container-grid ${isLandscape ? '' : 'portrait'}`}>

          <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-input-title ${storeNameError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Nombre de la tienda</div>
            <input value={storeName} className={`userform-input ${storeNameError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkStoreName(e.target.value) }}></input>
            <div className='userform-warning-text'>{storeNameError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className='userform-input-container'>
            <div className={`userform-input-title ${localNumberError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Número de local</div>
            <input className={`userform-input ${localNumberError ? 'error' : ''}`} type='number' onChange={(e: any) => { checkLocalNumber(e.target.value) }}></input>
            <div className='userform-warning-text'>{localNumberError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-input-title ${mallNameError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Centro comercial</div>
            <input value={mallName} className={`userform-input ${mallNameError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkMallName(e.target.value) }}></input>
            <div className='userform-warning-text'>{mallNameError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className='userform-input-container'>
            <div className={`userform-input-title ${promissoryNoteError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Pagaré</div>
            <input className={`userform-input ${promissoryNoteError ? 'error' : ''}`} type='number' onChange={(e: any) => { checkPromissoryNote(e.target.value) }}></input>
            <div className='userform-warning-text'>{promissoryNoteError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className={`userform-input-checkbox ${acceptTermsError ? 'error' : ''}`}>
            <input id='legal_terms_accept' type='checkbox' onChange={(e: any) => { checkTerms(e.target.checked) }}></input>
            <div className='userform-checkbox-text'>
              Acepto los <a className='userform-checkbox-link' href='https://www.sistecredito.com/terminos-y-condiciones-generales/' target='_blank' rel='noreferrer'>Términos y condiciones de Sistecredito</a>
            </div>
          </div>
        </div>

        <div className={`userform-send-button ${isLandscape ? '' : 'portrait'} ${(acceptTermsError || storeNameError || localNumberError || promissoryNoteError || mallNameError || sendingForm) ? 'error' : ''}`} onClick={() => { if (!acceptTermsError && !storeNameError && !localNumberError && !mallNameError && !promissoryNoteError && !sendingForm) verifyAllInputs() }}>
          <div className='userform-send-button-text'>{sendingForm === true ? 'ENVIANDO' : 'CONTINUAR'}</div>
        </div>

      </div>
    </div>
  );
}